var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextBlock',_vm._b({},'TextBlock',{
    size: _vm.size,
    variant: _vm.variant,
    lineHeight: _vm.lineHeight,
    text: _vm.text,
    tag: _vm.tag,
  },false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }